import auth from '@/router/auth'
import PromotionIndex from '@/components/keys/Index'
import PromotionCreate from '@/components/keys/Create'
import PromotionUpdate from '@/components/keys/Update'
import PromotionShow from '@/components/keys/Show'

export default [
  {
    path: '/keys',
    name: 'keys-index',
    component: PromotionIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/:level_id/keys/create',
    name: 'keys-create',
    component: PromotionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/:level_id/keys/update/:key_id',
    name: 'keys-update',
    component: PromotionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/levels/:level_id/keys/show/:key_id',
    name: 'keys-show',
    component: PromotionShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/keys/router.js